import axios from 'axios';

// URL base de la API
const BASE_URL = process.env.REACT_APP_API_URL;

// Crear instancia de Axios
const client = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
  },
});

export default client;
